module.exports = __webpack_public_path__ + "img/P150T_weapon_128.debefb37.png";